<template>
  <nav class="dn-submenu">
    <a
      v-for="item, index in items"
      :key="index"
      :class="`dn-submenu__item${item.className ? ' ' + item.className : ''}`"
      :href="item.href"
      :target="item.target"
      v-linkset="item.url_id"
    >
      <span class="dn-icon dn-icon-arrow-right"></span><span class="dn-submenu__text" v-html="item.label"></span>
    </a>
    <a class="dn-submenu__item" href="javascript:void(0);" @click="showAttributeDialog"><span class="dn-icon dn-icon-arrow-right"></span><span class="dn-submenu__text">属性確認</span></a>
  </nav>
</template>



<script>
export default {
  name: 'dn-submenu',

  computed: {
    items() { return this.$store.getters['navigation/submenus'] },
  },

  methods: {
    showAttributeDialog() {
      dn.attributeDialog.show();
    },
  },
}
</script>


// WEBPACK FOOTER //
// Submenu.vue?52f868ba